<template>
    <div v-show="showed">
        <div id="smartcaptcha"></div>
        <d-modal
            v-cloak
            :name="uniqName"
            @close="closeModal"
            size="sms"
            no-scroll
            :disable-container="true"
            popup-title="Подтвердите данные"
        >
            <div class="d-modal__text">Код отправлен на номер: <span class="ym-disable-keys">{{ this.phone }}</span></div>
            <input type="text" ref="inputCode" class="d-modal__input-sms" :class="{'_invalid': isPhoneError}" v-focus maxlength="6" v-mask="'######'" placeholder="Введите код из СМС" inputmode="numeric" v-model="code" @keyup.enter.prevent="sendCode">
            <p class="form-error text-center _mt-16" v-if="isPhoneError">Неправильный код</p>
            <p class="form-error text-center _mt-16" v-if="code.length < 1 && isTrySmsSubmit">Поле обязательное для заполнения.</p>

            <a @click.prevent="sendCode" class="button button_black button_width-100 _mt-24" :class="{ 'button-disabled': !captchaChecked || attemptTime !== 0 }">
                <span>Подтвердить</span>
            </a>
            <div class="d-modal__timer">
                <p v-show="currentTime > 0 && captchaChecked" class="text-center _pb-16">Отправить код повторно через {{ `${("0" + currentTime).slice(-2)}` }} сек.</p>
                <a v-show="currentTime < 1 && captchaChecked" class="button button_black button_width-100" @click.prevent="checkVerification">
                    <span>Отправить код повторно</span>
                </a>
            </div>
            <p class="p2 gray-text-light _mt-16">Данные обрабатываются SmartCaptcha</p>
        </d-modal>
    </div>
</template>

<script>
    import { sendCode, verifyCode, getSessid } from '../../assets/js/utils'
    import DModal from '../dModal.vue';
    const axios = require('axios');
    import { focus } from '../../assets/js/vue/directives';
    import { mask } from 'vue-the-mask';

    export default {
        name: 'ModalWithYandexCaptcha',
        components: {
            DModal,
        },
        props: {
            phone: {
                type: String,
                default: "",
            },
            endpoint: {
                type: String,
                default: "",
            },
            privateFlag: {
                type: Boolean,
                default: false,
            },
            isSendingDocs: { // для документов HR
                type: Boolean,
                default: false,
            },
            onlyRequest: { // для случаев, когда нужен только запрос на капчу, без вызова модалки
                type: Boolean,
                default: false,
            },
            onlySend: { // для случаев, когда нужна только модалка и отправка кода (смс отправляет бэк)
                type: Boolean,
                default: false,
            },
            hideYaPdn: { // если требуется скрыть плашку справа
                type: Boolean,
                default: false,
            },
            requested: {
                type: Boolean,
                default: false
            }
        },
        directives: {
            focus,
            mask,
        },
        data() {
            return {
                currentTime: 0,
                timer: null,
                code: '',
                startTimeCodeLive: 29,
                attemptTime: 0,
                attemptTimer: null,
                showed: false,
                codeRequested: false, // отметка, что код уже запрошен и не надо его запрашивать снова при открытии модалки
                isTrySmsSubmit: false,
                isPhoneError: false,
                token: null,
                isVerifiedUrl: '/rest/v1/captcha/smart/isVerified',
                postVerifiedUrl: '/rest/v1/captcha/smart',
                captchaChecked: false,
                sessid: window.config.bitrix_sessid,
                uniqName: null
            }
        },
        methods: {
            getUniqName() {
                return this.uniqName = `phoneConfirm${Math.floor(Math.random() * (10000000 - 1) + 1)}`;
            },
            startTimer() {
                this.currentTime = this.startTimeCodeLive;
                this.timer = setInterval(() => {
                    this.currentTime -= 1;
                }, 1000)
            },
            startAttemptTimer() {
                this.attemptTime = 15;
                this.attemptTimer = setInterval(() => {
                    this.attemptTime -= 1;
                }, 1000)
            },
            closeModal() {
                this.showed = false;
                this.$emit('closeCaptchaSms');

                // Временный костыль для private-banking
                if (this.$props.privateFlag) {
                    document.querySelector('.header-main').setAttribute('style', 'z-index: 99999');
                }
            },
            stopTimer() {
                clearTimeout(this.timer)
                this.codeRequested = false;
            },
            stopAttemptTimer() {
                clearTimeout(this.attemptTimer)
            },
            /**
             * TODO: use common logic from '/local/templates/redesign/src/assets/js/vue/utlis/captcha/index.js'
             * @see '/local/templates/redesign/src/assets/js/vue/utlis/useDadata/index.js'
             */
            initCaptcha() {
                this.waitForYandexCaptchaScriptLoading().then(() => {
                    let interval = setInterval(() => {
                        const container = document.getElementById('smartcaptcha');
                        if (container) {
                            const widgetId = window.smartCaptcha.render(document.getElementById('smartcaptcha'), {
                                sitekey: window.config.ysc_public_key,
                                hl: 'ru',
                                invisible: true,
                                callback: (token) => {
                                    if (typeof token === "string" && token.length > 0) {
                                        this.token = token;
                                    }
                                }
                            });

                            const unsubscribe = window.smartCaptcha.subscribe( // eslint-disable-line
                            widgetId,
                            'success',
                            () => this.token = document.querySelector('[name="smart-token"]').getAttribute('value')
                            );

                            window.smartCaptcha.execute(widgetId);
                            if (this.$props.hideYaPdn) this.hideYandexInfo()
                            clearInterval(interval);
                        }
                    }, 100)
                })
            },
            checkVerification() {
                axios.get(`${this.isVerifiedUrl}?sessid=${this.sessid}`, {headers: {'Accept': 'application/vnd.api+json'}})
                    .then((response) => {
                        if (!response.data.data.attributes.verified) {
                            return this.initCaptcha();
                        }
                        else {
                            this.captchaChecked = true;
                            if (!this.onlySend) this.requestCode();
                            this.stopTimer();
                            this.startTimer();
                        }
                    })
                    .catch((res)=> {
                        if (res.response.status === 419) {
                            getSessid()
                                .then(res => {
                                    this.sessid = res.data;
                                    this.checkVerification();
                                })
                        }
                        else if (res.response.status === 429) {
                            this.$modal.show('tooManyRequests');
                            this.$modal.hide(this.uniqName);
                        }
                        else {
                            return this.initCaptcha();
                        }
                    })
            },
            verificationRequest() {
                let formData = {
                    data: {
                        type: "smartCaptchaVerify",
                        attributes: {
                            token: this.token
                        }
                    }
                }

                axios.post(`${this.postVerifiedUrl}?sessid=${this.sessid}`, formData, {headers: {'Content-Type': 'application/vnd.api+json'}})
                .then((response) => {
                    if (response.data.data.attributes.verified && !this.$props.onlyRequest) {
                        this.captchaChecked = true;
                        this.requestCode();
                        this.startTimer();
                    }
                    else {
                        this.$emit('smsConfirmed');
                    }
                })
                .catch((res) => {
                    if (res.response.status === 419) {
                        getSessid()
                            .then(res => {
                                this.sessid = res.data;
                                if (this.$props.onlyRequest) {
                                    this.verificationRequest();
                                }
                                else {
                                    this.requestCode();
                                }
                            })
                    }
                    else if (res.response.status === 429) {
                        this.$modal.show('tooManyRequests');
                        this.$modal.hide(this.uniqName);
                    }
                });
            },
            // запрос кода в смс
            requestCode() {
                sendCode(this.$props.phone, this.$props.endpoint, this.sessid)
                    .then(() => {
                        this.codeRequested = true;
                    })
                    .catch(res => {
                        if (res.response.status === 419) {
                            getSessid()
                                .then(res => {
                                    this.sessid = res.data;
                                    this.requestCode();
                                })
                        }
                        if (res.response.status === 403) {
                            this.checkVerification();
                        }

                        if (res.response.status === 429) {
                            this.$modal.show('tooManyRequests');
                            this.$modal.hide(this.uniqName);
                        }
                    });
            },
            sendCode() {
                this.isTrySmsSubmit = true;

                if (this.captchaChecked && this.code) {
                    verifyCode(this.code, this.$props.endpoint, this.sessid)
                        .then((res) => {
                            if (res.data.result && res.data.result.message === 'Verified') {

                                if (this.isSendingDocs) {
                                    this.$emit('repeatSendDocs');
                                }

                                this.$modal.hide(this.uniqName);
                                this.isPhoneError = false;
                                this.code = '';
                                this.isTrySmsSubmit = false;
                                this.$emit('smsConfirmed');

                            } else {
                                this.isPhoneError = true;
                            }
                        })
                        .catch(res => {
                            if (res.response.status === 419) {
                                getSessid()
                                    .then(res => {
                                        this.sessid = res.data;
                                    })
                            }
                            if (res.response.status === 403) {
                                this.checkVerification();
                            }
                            if (res.response.status === 429) {
                                this.startAttemptTimer();
                            }
                        });
                }
            },
            hideYandexInfo() {
                let interval = setInterval(() => {
                    if (document.querySelector('.SmartCaptcha-Shield')) {
                        document.querySelector('.SmartCaptcha-Shield').classList.add('hidden');
                        clearInterval(interval);
                    }
                }, 10)
            },
            waitForYandexCaptchaScriptLoading() {
                return new Promise((res, rej) => {
                    if (window.smartCaptcha) return res();

                    var intervalId = setInterval(() => {
                        if (window.smartCaptcha) {
                            clearInterval(intervalId);
                            clearTimeout(timeoutId);
                            return res();
                        }
                    }, 100);

                    var timeoutId = setTimeout(() => {
                        clearInterval(intervalId);
                        clearTimeout(timeoutId);
                        rej('yandex captcha script loading timeout');
                    }, 5000);
                })
            },
        },
        watch: {
            token() {
               this.verificationRequest();
            },
            currentTime(val) {
                if (val < 1) this.stopTimer()
            },
            attemptTime(val) {
                if (val < 1) this.stopAttemptTimer()
            },
            phone(val, oldVal) {
                // сбрасываем всё, если пользователь поменял номер телефона
                if (val !== oldVal) {
                    this.codeRequested = false;
                    this.showed = false;
                    this.$emit('closeCaptchaSms');
                }
            },
            requested(val) {
                if (val) {
                    this.getUniqName();

                    this.$nextTick(() => {
                        if (!this.$props.onlyRequest || this.$props.onlySend) {
                            this.showed = true;
                            this.$modal.show(this.uniqName);
                        }

                        if (!this.codeRequested) {
                            setTimeout(() => {
                                this.checkVerification();
                            }, 100)
                        }
                    })
                }
            }
        },
        mounted() {
            if (this.$props.onlyRequest && !this.$props.onlySend) {
                this.initCaptcha();
            }

            // Временный костыль для private-banking
            if (this.$props.privateFlag) {
                document.querySelector('.header-main').setAttribute('style', 'z-index: 99');
            }
        }
    }
</script>
